import { render, staticRenderFns } from "./RenameModal.vue?vue&type=template&id=571cdb48&"
import script from "./RenameModal.vue?vue&type=script&lang=js&"
export * from "./RenameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports